// extracted by mini-css-extract-plugin
module.exports = {"icon":"PopoverMenu_icon__2x6tf","dropdownButton":"PopoverMenu_dropdownButton__3A6RT","list":"PopoverMenu_list__cW8h9"};